import axios from "axios";
import { environment } from "../../environment";

export async function saveAccess(page) {
    const previousPage = document.referrer;
    if (process.env.NODE_ENV !== 'development') {
        await axios.post(environment.backendUrl + "saveAccess", { reference: previousPage, page: page })
    }
}